export const QUESTION_KIND = {
  ONLY_TEXT: "onlyText",
  TEST: "test",
  DROPDOWN: "dropdown",
  DND: "dnd",
  VIDEO: "video",
};

export function resolveQuestionKind(question) {
  if (!question || typeof question !== "object") {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.type === "text") {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.onlyText) {
    return QUESTION_KIND.ONLY_TEXT;
  }

  if (question.type === "dnd") {
    return QUESTION_KIND.DND;
  }

  if (question.isGame) {
    return QUESTION_KIND.DND;
  }

  if (question.type === "video") {
    return QUESTION_KIND.VIDEO;
  }

  if (question.type === "dropdown") {
    return QUESTION_KIND.DROPDOWN;
  }

  if (question.type === "interactive") {
    return QUESTION_KIND.DROPDOWN;
  }

  if (question.type === "test" || question.isTest) {
    return QUESTION_KIND.TEST;
  }

  if (Array.isArray(question.dropdownQuestionParts)) {
    return QUESTION_KIND.DROPDOWN;
  }

  if (Array.isArray(question.options) && question.correctAnswer) {
    return QUESTION_KIND.TEST;
  }

  return QUESTION_KIND.ONLY_TEXT;
}
